import { render, staticRenderFns } from "./CreateRootFolderModal.vue?vue&type=template&id=1256bde3&"
import script from "./CreateRootFolderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateRootFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports